import { Grid } from "@material-ui/core";
import React from "react";

import PressManagementCard from "./PressManagementCard";

/**
 * PressManagementPageコンポーネント.
 *
 * @return {object} コンポーネント
 */
function PressManagementPage() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <PressManagementCard />
      </Grid>
    </Grid>
  );
}

export default PressManagementPage;
